import React from 'react'
import LoginPage from '../Pages/Login/LoginPage'

function Loginpage() {
  return (
    <>
        <LoginPage />
    </>
  )
}

export default Loginpage
